import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/home/mspc_main_head.png'
import _imports_1 from '@/assets/image/home/mspc_word_API.png'
import _imports_2 from '@/assets/image/home/mspc_img_finger.png'
import _imports_3 from '@/assets/image/home/mspc_img_like.png'
import _imports_4 from '@/assets/image/home/mspc_excellent_works.png'
import _imports_5 from '@/assets/image/home/mspc_f_q.png'


const _withScopeId = n => (_pushScopeId("data-v-73f9b0af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "titleHead" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "slogan",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "一款为你的照片精心准备的AI魔法棒")
], -1))
const _hoisted_3 = { class: "introList" }
const _hoisted_4 = { class: "introLeft" }
const _hoisted_5 = { class: "introHead" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "introDesc" }
const _hoisted_9 = { class: "introRight" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "introRight" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "introLeft" }
const _hoisted_14 = { class: "introHead" }
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "introDesc" }
const _hoisted_18 = { class: "middleContent" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"svgBox\" data-v-73f9b0af><svg viewBox=\"0 0 120 12\" data-v-73f9b0af><defs data-v-73f9b0af><path id=\"wave\" d=\"M 0,10 C 30,10 30,15 60,15 90,15 90,10 120,10 150,10 150,15 180,15 210,15 210,10 240,10 v 28 h -240 z\" data-v-73f9b0af></path></defs><use id=\"wave3\" class=\"wave\" xlink:href=\"#wave\" x=\"0\" y=\"-5\" data-v-73f9b0af></use><use id=\"wave2\" class=\"wave\" xlink:href=\"#wave\" x=\"0\" y=\"-8\" data-v-73f9b0af></use><use id=\"wave1\" class=\"wave\" xlink:href=\"#wave\" x=\"0\" y=\"-7\" data-v-73f9b0af></use></svg></div>", 1)
const _hoisted_20 = { class: "codePreview" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "codeHead" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "slogan" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "tips" }, "让你可以专注于构建奇思妙想的AI生产力工具")
], -1))
const _hoisted_22 = { class: "codeContent" }
const _hoisted_23 = { class: "preBtnList" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "尝试一下", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_26 = [
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "更多模型", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1))
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<div class=\"svgBox svgBox2\" data-v-73f9b0af><svg viewBox=\"0 0 120 12\" data-v-73f9b0af><defs data-v-73f9b0af><path id=\"wave\" d=\"M 0,10 C 30,10 30,15 60,15 90,15 90,10 120,10 150,10 150,15 180,15 210,15 210,10 240,10 v 28 h -240 z\" data-v-73f9b0af></path></defs><use id=\"wave3\" class=\"wave2\" xlink:href=\"#wave\" x=\"0\" y=\"-5\" data-v-73f9b0af></use><use id=\"wave2\" class=\"wave2\" xlink:href=\"#wave\" x=\"0\" y=\"-8\" data-v-73f9b0af></use><use id=\"wave1\" class=\"wave2\" xlink:href=\"#wave\" x=\"0\" y=\"-7\" data-v-73f9b0af></use></svg></div>", 1)
const _hoisted_31 = { class: "modelContent" }
const _hoisted_32 = { class: "modelItem" }
const _hoisted_33 = { class: "modelBg" }
const _hoisted_34 = ["src"]
const _hoisted_35 = { class: "modelIntro" }
const _hoisted_36 = { class: "modelTitle" }
const _hoisted_37 = { class: "modelAuthor" }
const _hoisted_38 = { class: "modelStar" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "modelId" }
const _hoisted_41 = { class: "modelDesc" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tryBtn" }, [
  /*#__PURE__*/_createElementVNode("p", null, "使用此模型")
], -1))
const _hoisted_43 = { class: "showContent" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "showHeader" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "showTitle" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_4,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "showTips" }, "通过喵手AI创作的优秀作品")
], -1))
const _hoisted_45 = { class: "showMain" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "QAContent" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "QAHeader" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "QATitle" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "QATips" }, "关于妙手AI最常见的问题")
], -1))
const _hoisted_49 = { class: "QAList" }
const _hoisted_50 = { class: "QAQ" }
const _hoisted_51 = { class: "title" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = ["src"]
const _hoisted_54 = { class: "QAA" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descArr, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "introItem"
        }, [
          (index % 2 == 0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      class: "labelIcon",
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_6),
                    _createElementVNode("img", {
                      class: "labelTitle",
                      src: item.titleIcon,
                      alt: ""
                    }, null, 8, _hoisted_7)
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.desc), 1),
                  _createVNode(_component_router_link, {
                    to: { name: item.url },
                    class: "tryBtn"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.btnLabel), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("img", {
                    class: "introBg",
                    src: item.imgUrl,
                    alt: ""
                  }, null, 8, _hoisted_10)
                ])
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("img", {
                    class: "introBg",
                    src: item.imgUrl,
                    alt: ""
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("img", {
                      class: "labelIcon",
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_15),
                    _createElementVNode("img", {
                      class: "labelTitle",
                      src: item.titleIcon,
                      alt: ""
                    }, null, 8, _hoisted_16)
                  ]),
                  _createElementVNode("div", _hoisted_17, _toDisplayString(item.desc), 1),
                  _createVNode(_component_router_link, {
                    to: { name: item.url },
                    class: "tryBtn"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(item.btnLabel), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ], 64))
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createElementVNode("div", _hoisted_20, [
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("pre", null, _toDisplayString(_ctx.previewCode), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", {
            class: "tryBtn btn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.jumpUrl2 && _ctx.jumpUrl2(...args)))
          }, _hoisted_26),
          _createElementVNode("div", {
            class: "moreBtn btn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.jumpUrl && _ctx.jumpUrl(...args)))
          }, _hoisted_29)
        ])
      ]),
      _hoisted_30
    ]),
    _createElementVNode("div", _hoisted_31, [
      _createVNode(_component_swiper, {
        slidesPerView: 2,
        spaceBetween: 30,
        navigation: true,
        pagination: {
          clickable: true,
        },
        modules: _ctx.modules,
        class: "mySwiper",
        centeredSlides: true,
        loop: true,
        "grab-cursor": false
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelsArr, (item, index) => {
            return (_openBlock(), _createBlock(_component_swiper_slide, { key: index }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("img", {
                      src: item.modelUrl,
                      alt: ""
                    }, null, 8, _hoisted_34)
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("p", _hoisted_36, _toDisplayString(item.modelTitle), 1),
                    _createElementVNode("p", _hoisted_37, "作者：" + _toDisplayString(item.modelAuthor), 1),
                    _createElementVNode("p", _hoisted_38, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (_item) => {
                        return _createElementVNode("img", {
                          class: "starItem",
                          key: _item,
                          src: 
                    item.modelStar >= _item
                      ? require('@/assets/image/home/mspc_star_s.png')
                      : require('@/assets/image/home/mspc_star_n.png')
                  ,
                          alt: ""
                        }, null, 8, _hoisted_39)
                      }), 64))
                    ]),
                    _createElementVNode("p", _hoisted_40, "模型ID：" + _toDisplayString(item.modelId), 1),
                    _createElementVNode("p", _hoisted_41, _toDisplayString(item.modelDesc), 1),
                    _hoisted_42
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", {
          class: "showBody",
          style: _normalizeStyle({ width: `${_ctx.circleArr.length * 300}px` })
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.circleArr, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(['imgColumn', `imgColumn${index}`]),
              key: index
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item, (_item, _index) => {
                return (_openBlock(), _createElementBlock("img", {
                  class: "imgContent",
                  src: _ctx.modelBgArr[index][_index],
                  alt: "",
                  key: _index
                }, null, 8, _hoisted_46))
              }), 128))
            ], 2))
          }), 128))
        ], 4)
      ])
    ]),
    _createElementVNode("div", _hoisted_47, [
      _hoisted_48,
      _createElementVNode("div", _hoisted_49, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qaArr, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "QAItem",
            key: index
          }, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("p", _hoisted_51, _toDisplayString(item["title"]), 1),
              _createElementVNode("p", {
                class: "plus",
                onClick: ($event: any) => (_ctx.showAnswer(index))
              }, [
                _createElementVNode("img", {
                  src: 
                  item.isShow
                    ? require('@/assets/image/home/mspc_-.png')
                    : require('@/assets/image/home/mspc_+.png')
                ,
                  alt: ""
                }, null, 8, _hoisted_53)
              ], 8, _hoisted_52)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_54, [
              _createElementVNode("p", null, _toDisplayString(item["content"]), 1)
            ], 512), [
              [_vShow, item.isShow]
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}